
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import Header from "./Header";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import LoginProcess from "./loginProcess";
import { authFetch, getAuthInfo, redirectToLogin } from "./authFetch";

import { loadStripe } from "@stripe/stripe-js";
import {
  PaymentElement,
  Elements,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

//const intentGW = process.env.REACT_APP_PAYMENTGATEWAY;
const intentGW = process.env.REACT_APP_GATEWAY

var u = JSON.parse(sessionStorage.getItem("userinfo"));

const checkAdminEndPoint = process.env.REACT_APP_ISADMIN_END_POINT;


      

function New() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [Message, setMessage] = useState("");
  const [Info, setInfo] = useState(false);
  const [stage, setStage] = useState(0);
  const [terms, setTerms] = useState("");
  
  const [priv, setPriv] = useState(0);
  const [sig, setSig] = useState({ signed: 0, sig: "" });
  const [serie, setSerie] = useState(0);
  const [coin, setCoin] = useState(0);
  const [userinfo, setUserinfo] = useState({ id: 0 });
  const [wallet, setWallet] = useState("");
  const [europe, setEurope] = useState(-1);
  const [name, setName] = useState("");
  const [vat, setVat] = useState("");
  const [free, setFree] = useState("");
  
  


  const [myparams, setMyParams] = useSearchParams();
  


  var tierprices = [
    parseInt(process.env.REACT_APP_TIER0),
    parseInt(process.env.REACT_APP_TIER1),
    parseInt(process.env.REACT_APP_TIER2),
    parseInt(process.env.REACT_APP_TIER3),
  ];

  const TotalStages = 8;
  const navigate = useNavigate();
  const idea = useRef();

 const { id } = useParams();
  

    useEffect(() => {
      //verficar se ele é admin!
      //para por o butao de admin a funcionar!

         

          if (id ) { 
          
          

            async function getPhrase(id) {
            try {
              const response = await fetch(process.env.REACT_APP_SINGLE_REQUEST_END_POINT + id);
              
              if (!response.ok) {
                throw new Error('Failed to fetch phrase');
              }
              
              const data = await response.json();
              console.log(data);
                idea.current.value = data.phrase;
              return data;
            } catch (error) {
              console.error(error);
            }
            }
            getPhrase(id);
            }
      
      
      var u = getAuthInfo();

      if (u !== null) {
          const checkIfAdmin = async () => {
            try {
              const response = await authFetch(checkAdminEndPoint + u.id, { method: "GET" });
              const data = await response.json();
              if (data.error) {
                sessionStorage.removeItem("userinfo");
                setIsAdmin(false);
                return;
              }
              setIsAdmin(data.isadmin);
            } catch (error) {
              setIsAdmin(false);
            }
          };
          checkIfAdmin();
      }
    }, []);
  
  


  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
  }

  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
  }

  function correctphrase(str) {
    str = str.toLowerCase();
    str = replaceAll(str, " ", "_");
    str = replaceAll(str, "\n", "|");
    return str;
  }

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    const params = new URLSearchParams(window.location.search);
    var vars = query.split("&");
    var out = "";

    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return out;
  }

  function isEmpty(str) {
    return !str.trim().length;
}

  async function changeStage(dir) {
    //hide all messages
    setInfo(false);
    setMessage("");
    //can I go forward?

    if (dir === -2) {
      dir = 0;
    } else {
      if (stage === 0) {
        
        var idea = document.getElementById("idea");
        
        if (idea.value === "") {
          setMessage("no empty ideas");
          setInfo(true);
          setTimeout(() => {
            setInfo(false);
          }, 1500);
          return;
        } else {
          setMessage("");
        }
      
      }
      if (stage === 1) { 
          if (id && dir >0) { 
          dir = 2;
          }
        
      }
      if (stage === 2) { 
        if (dir > 0) {
          if (free) {
            dir = 6
          }
        }
      }

      if (stage === 3) {
        if (sig.signed === 1 && sig.sig.replace(/\s/g, "") === "")
          var signature = document.getElementById("sig");
        if (signature) {
          if (signature.value === "") {
            setMessage("no empty signatures");
            setInfo(true);
            setTimeout(() => {
              setInfo(false);
            }, 1500);
            return;
          } else {
            setMessage("");
          }
        }
        if (id && dir <0) { 
          dir = -2;
          }
      }

      if (stage === 4) {
        if (dir > 0) { 
        if (!priv) {
          var price = document.getElementById("price");
            if (isEmpty(price.value) || !isNumber(price.value)) {
              setMessage("We need a price");
              setInfo(true);
              setTimeout(() => {
                setInfo(false);
              }, 1500);
              return;
            } else {
              setMessage("");
            }
          
        }
        }
        }
      if (stage === 7) {
        if (dir > 0) { 
        if (isEmpty(name)){
            setMessage("We need a name");
              setInfo(true);
              setTimeout(() => {
                setInfo(false);
              }, 1500);
              return;
        } else {
              setMessage("");
        }
       
        //create US user
      }
      }
    }


          if (stage === 8) { 
            console.log(dir);
            if (dir < 0 && free) {
              dir = -6;
            }
          }

    var stages = document.querySelectorAll(".stages");

    stages.forEach(function (stage, index) {
      stage.style.display = "none";
    });

    //paypal

    if (getQueryVariable("payment_intent") && stage !== 8) {
      dir = 8;
    }

    if (stage === 4 && dir > 0 && priv === 1) {
      dir = 2;
    }

    if (stage === 6 && dir < 0 && priv === 1) {
      dir = -2;
    }



    var nstage = stage + dir;
    var cStage = document.getElementById("stage" + nstage);
    cStage.style.display = "flex";

    if ((stage) => 0 && stage <= TotalStages) {
      setStage(stage + dir);
    }
  }

  function checkNext() {
    //stage !== 6 && (wallet != "" && stage === 4)  && stage < TotalStages
    if (stage === 0) return true;
    if (stage === 1) return true;
    if (stage === 2) return true;
    if (stage === 3) return true;
    if (stage === 4) return true;
    if (stage === 5 ) return true;
    if (stage === 6 && wallet !== "") return true;
    if (stage === 7 && europe !== -1 && !isEmpty(name) ) return true;
    if (stage === 8) return false;
    if (stage === 9) return false;
    return false;
  }

  function checkPrev() {
    if (stage === 10) return false;
    if (stage > 0) return true;
    return false;
  }

  function Control({ stage }) {
    return (
      <div className="absolute bottom-20 w-full flex border-red-500 border-0 h-10">
        {checkPrev() > 0 ? (
          <div
            className="mouse2 flex-1 pl-32 "
            onMouseDown={() => {
              changeStage(-1);
            }}
          >
            {"Prev"}{" "}
          </div>
        ) :  <div className="fmouse2 flex-1 text-right pl-32"></div>}
        <div className="flex-1 text-center"></div>
        {checkNext() ? (
          <div
            className="mouse2 flex-1 text-right pr-32 "
            onMouseDown={() => {
              changeStage(1);
            }}
          >
            {" "}
            {"Next"}{" "}
          </div>
        ) : <div className="fmouse2 flex-1 text-right pr-32"></div>}
        
      </div>
    );
  }

  function Messages(props) {
    

    return (
      <>
        <div className="messages">
          <div
            className={props.Info ? "alert-show " : "AlertfadeOut "}
            {...(props.Info ? "hidden" : null)}
          >
            {" "}
            {props.message}{" "}
          </div>
        </div>
      </>
    );
  }

  function WalletConnectDivs({ serie, priv }) {
    function ownWallet() {
      setWallet(process.env.REACT_APP_OWNWALLET);
    }

    function clearOwnWallet() {
      setWallet("");
    }

    async function ConnectToWallet(setWallet, priv, serie) {
      if (typeof window.ethereum !== "undefined") {
        // Do something
        window.ethereum
          .request({ method: "eth_requestAccounts" })
          .then((res) => {
            // Return the address of the wallet
            setWallet(res[0]);
          });

        window.ethereum.on("accountsChanged", handleAccountsChanged);

        function handleAccountsChanged(accounts) {
          if (accounts.length === 0) {
            setWallet("");
          }
        }
        function handAccountDisconnect() {
          setWallet("");
        }

        window.ethereum.on("disconnect", handAccountDisconnect);
      } else {
        
      }
    }

    return (
      <div className="newOptions_class">
        {wallet === "" ? (
          <span>
            <span
              className="mouse selected"
              onMouseDown={() => {
                ConnectToWallet(setWallet, serie, priv);
              }}
            >
              [ Connect to your Wallet ]
            </span>
            <br />
            or
            <br />
            <span
              className="mouse selected"
              onMouseDown={() => {
                ownWallet();
              }}
            >
              [ Connect to HyperWallet ]
            </span>
          </span>
        ) : wallet === process.env.REACT_APP_OWNWALLET ? (
          <div>
            {" "}
            You have chosen to mint your idea on HyperWallet
            <br />
            <br />
            ( that is our wallet where we hold your tokens on your behalf )
            <br /> <br />
            <span
              className=" mouse selected"
              onMouseDown={() => {
                clearOwnWallet();
              }}
            >
              Disconnect HyperWallet
            </span>
          </div>
        ) : (
          <div>
            {" "}
            You have chosen to mint your idea on your wallet
            <br />
            <br />
            {wallet}
            <br />
            <br />
            <span></span>
          </div>
        )}
      </div>
    );
  }

  useEffect(() => {
    changeStage(-2);
    var d = JSON.parse(sessionStorage.getItem("userinfo"));
    if (d != null && userinfo.id == 0) {
      setUserinfo(d);
    }
  }, []);

  function close() {
    setInfo(false);
    navigate("/");
  }

  function isNumber(value) {
    var regex = /^[0-9]+$/;
    return value.match(regex);
  }

  const handleSave_admin = (event) => { 
 
    var value = 0;
      if (serie === 0) value = process.env.REACT_APP_TIER0;
      if (serie === 1) value = process.env.REACT_APP_TIER1;
      if (serie === 2) value = process.env.REACT_APP_TIER2;
      if (serie === 3) value = process.env.REACT_APP_TIER3;
      var Ccurrency = "EUR";
      var wwprice = 0;
      if (wallet === process.env.REACT_APP_OWNWALLET) {
        wwprice = 4000;
      } else {
        wwprice = 2000;
      }
    
    var ddata = {
        price:  value,
        phrase: correctphrase(idea.current.value),
        sig: document.getElementById("sig")
          ? document.getElementById("sig").value
          : "",
        wallet: wallet,
        type: serie,
        priv: priv,
        currency: Ccurrency,
        Wprice: wwprice,
        sprice: document.getElementById("price")
          ? document.getElementById("price").value * 100
          : 0,
        HWallet: wallet === process.env.REACT_APP_OWNWALLET ? true : false,
      userId: userinfo.id,
      
      };

         var u = JSON.parse(sessionStorage.getItem("userinfo"));

        var h = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + u.token,
      };
      var options = {
        method: "POST",
        mode: "cors",
        headers: h,
        body: JSON.stringify(ddata),
      };
    
     fetch(`${process.env.REACT_APP_ADMINGO}`, options)
      .then((result) => {
        console.log(result);
        changeStage(2);  
      })
      
  }


  const handleSave = async (event) => {
    console.log("[handleSave] begin ");

       if (free) { 
          console.log("[handleSave] free ");
          var u = JSON.parse(sessionStorage.getItem("userinfo"));
          console.log(u);
          if (!u) { 
            console.log("user logged off");
              sessionStorage.removeItem("userinfo");         
              
              setIsAdmin(false); 
            return
          }
          var ddata = {
            phrase: correctphrase(idea.current.value),
            userId: userinfo.id,
            name: name,
            free: true,
            token: u.token
          };
          console.log(ddata);
          var h = {
                "Content-Type": "application/json",
                Authorization: "Bearer " + u.token,
          };
          var options = {
              method: "POST",
              mode: "cors",
              headers: h,
              body:  JSON.stringify(ddata),
          };
    
          await fetch(process.env.REACT_APP_SAVE_END_POINT + "free", options)
            .then((response) => response.json())
            .then(function (data) {
              console.log(data);
          });
         
          //vasco free
          changeStage(2);

          return;
       }
    
      console.log("[handleSave] Not Free! ")
    

    var value = 0;
    if (serie === 0) value = process.env.REACT_APP_TIER0;
    if (serie === 1) value = process.env.REACT_APP_TIER1;
    if (serie === 2) value = process.env.REACT_APP_TIER2;
    if (serie === 3) value = process.env.REACT_APP_TIER3;
    var Ccurrency = "";
    if (coin === 0) Ccurrency = "eur";
    if (coin === 1) Ccurrency = "usd";
    var wwprice = 0;
    if (wallet === process.env.REACT_APP_OWNWALLET) {
      wwprice = 4000;
    } else {
      wwprice = 2000;
    }

    fetch(`${process.env.REACT_APP_EXCHANGE}`)
      .then((currency) => {
        return currency.json();
      })
      .then(displayResults);

    function displayResults(currency) {
      
      if (coin === 0) {
        value = value * currency.rates["EUR"];
        wwprice = wwprice * currency.rates["EUR"];
      }

      changeStage(1);
    }
  };

  //afterlogin
  async function afterLogin() {
    setTimeout(async function () {
      var u = JSON.parse(sessionStorage.getItem("userinfo"));
      setUserinfo(u);
          var h = {
              "Content-Type": "application/json",
              Authorization: "Bearer " + u.token,
            };
            var options = {
              method: "GET",
              mode: "cors",
              headers: h,
            };
      
          await fetch(checkAdminEndPoint + u.id, options)
            .then((response) => response.json())
            .then(function (data) {
              setIsAdmin(data.isadmin);
            });
      
    }, 2000);
  }

  const CheckoutForm = (props) => {
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null);
    const [Loading, setLoading] = useState(0);

    const handleSubmit = async (event) => {
      //event.preventDefault();

      setLoading(1);

      if (elements == null) {
        setLoading(0);
        return;
      }

      if (stripe == null) {
        setLoading(0);
        return;
      }

      // Trigger form validation and wallet collection
      const { error: submitError } = await elements.submit();
      if (submitError) {
        // Show error to your customer
        setErrorMessage(submitError.message);
        setLoading(0);
        return;
      }

      // Get the payment element to check if it's complete
      const paymentElement = elements.getElement('payment');
      if (!paymentElement) {
        setErrorMessage("Payment element not ready");
        setLoading(0);
        return;
      }

      elements.on("ready", () => {

      });

      var value = 0;
      if (serie === 0) value = parseInt(process.env.REACT_APP_TIER0);
      if (serie === 1) value = parseInt(process.env.REACT_APP_TIER1);
      if (serie === 2) value = parseInt(process.env.REACT_APP_TIER2);
      if (serie === 3) value = parseInt(process.env.REACT_APP_TIER3);
      var Ccurrency = "EUR";
      var wwprice = 0;
      if (wallet === process.env.REACT_APP_OWNWALLET) {
        wwprice = 4000;
      } else {
        wwprice = 0;
      }

      // Calculate tax for European users (ensure numeric addition)
      var subtotal = parseInt(value) + parseInt(wwprice);
      var tax = 0;
      if (europe) {
        tax = Math.round(subtotal * 0.22); // 22% Italian VAT
      }
      var totalAmount = subtotal + tax;

      var ddata = {
        price:  value,
        phrase: correctphrase(idea.current.value),
        sig: document.getElementById("sig")
          ? document.getElementById("sig").value
          : "",
        wallet: wallet,
        type: serie,
        priv: priv,
        currency: Ccurrency,
        Wprice: wwprice,
        sprice: document.getElementById("price")
          ? document.getElementById("price").value * 100
          : 0,
        HWallet: wallet === process.env.REACT_APP_OWNWALLET ? true : false,
        userId: userinfo.id,
        name: name,
        vat: vat,
        europe: europe,
        tax: tax,
        subtotal: subtotal,
        totalAmount: totalAmount,
        delold: id ? id : 0
      };


      await fetch(intentGW + "/create-intent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: ddata, token: userinfo.token }),
      })
        .then((response) => response.json())
        .then(async function (data) {
          const clientSecret = data.clientSecret;


          const { error, paymentIntent } = await stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            clientSecret,
            elements,

            confirmParams: {
              return_url: "https://hyperuranium.io/new",
              payment_method_data: {
                billing_details: {
                  name: props.customerName || 'Customer',
                  address: {
                    line1: 'N/A',
                    city: 'N/A',
                    country: 'IT',
                    state: 'N/A',
                    postal_code: '00000',
                  }
                }
              }
            },
            redirect: "if_required",
          });

          if (error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            setErrorMessage(error.message);
            setLoading(0);
          } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
            setErrorMessage("Paid!");
            setTimeout(() => {
              changeStage(1);
            }, 1000);
          }
        })
        .catch((error) => {
          setErrorMessage("Payment failed: " + error.message);
            setTimeout(() => {
              setErrorMessage("");
            //vasco
            }, 30000);
          setLoading(0);
        });
    };

    const paymentElementOptions = {
      fields: {
        billingDetails: {
          address: 'never',
        }
      }
    };
    //vasco
    return (
      <>
        <form>
          <PaymentElement options={paymentElementOptions} />
            {/* Show error message to your customers */}
          {errorMessage && <div>{errorMessage}</div>}

        </form>

        {!Loading ? (
          <div
            className="z-50 border border-red-700 mouse2 paybutton"
            onClick={(e) => handleSubmit()}
          >
            [ Pay {euro.format(props.total / 100)} ]
          </div>
        ) : (
          <span className="mouse2 paybutton"> [ Please wait ]</span>
        )}
      </>
    );
  };

  let euro = Intl.NumberFormat("en-DE", {
    style: "currency",
    currency: "EUR",
  });

  //vasco
  function Stage9(props) {
    const [totals, setTotals] = useState(getTotal);

    useEffect(() => {}, []);

  
     const stripePromise = loadStripe(
      //"pk_live_51NsMC1J4lvUbSAbbUs7YOhEpv2CpVbPjkeklstm7GngjdPCWlJaQIsMgkXgNb6Gax9YAWR5CBsfeQr3dqZCV7tFq003AuPVZgW" // Live
      "pk_test_51SW1wtQrJEge4qHzQQ1iw9MG4CHgfn5zXITJhW511Lb3A8zZb2jfS93O9J8xRUkNtlgRfK2uBEOdZjPx8p2NsnpC00QUsvPgSg" // Sandbox
      
    );
    //vasco
    
    const options = {
      amount: getTotal().total,
      currency: "eur",
      mode: "payment",
      appearance: {
        /*...*/
      },
    };

    function getTotal() {
      var ideaCost = tierprices[serie];
      var mintCost;
      var total;
      var label;
      var walletType = wallet === process.env.REACT_APP_OWNWALLET;
      var tax = 0;
      var taxRate = 0;

      if (walletType) {
        mintCost = parseInt(process.env.REACT_APP_BASE_PRICE_HYP);
        label = "Mint with HyperWallet";
      } else {
        mintCost = 0;
        label = "";
      }

      var subtotal = ideaCost + mintCost;

      // Add Italian VAT (22%) for European users
      if (europe) {
        taxRate = 0.22;
        tax = Math.round(subtotal * taxRate);
      }

      total = subtotal + tax;
      return { idea: ideaCost, mint: mintCost, subtotal: subtotal, tax: tax, total: total, label: label };
    }

    
    return (
      <>
        {totals ? (
          <div className="buy2">
            <Elements stripe={stripePromise} options={options}>
              <div className="payinfo">
                <table>
                  <tbody>
                    {totals.label != "" ?
                    <tr>
                      <td>{totals.label} : </td>
                      <td> {euro.format(totals.mint / 100)}</td>
                    </tr>
                      :
                      null
                      }
                    <tr>
                      <td>Idea : </td>
                      <td>{euro.format(totals.idea / 100)}</td>
                    </tr>
                    {totals.tax > 0 ? (
                      <>
                        <tr>
                          <td>Subtotal : </td>
                          <td>{euro.format(totals.subtotal / 100)}</td>
                        </tr>
                        <tr>
                          <td>VAT (22%) : </td>
                          <td>{euro.format(totals.tax / 100)}</td>
                        </tr>
                      </>
                    ) : null}
                    <tr>
                      <td>Total : </td>
                      <td>{euro.format(totals.total / 100)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <CheckoutForm total={getTotal().total} customerName={name} />
            </Elements>
          </div>
        ) : null}
      </>
    );
  }

  const open = (url) => {
    window.open(url, "_self");
  };

  const openN = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className={"MainW"}>
      <Messages message={Message} Info={Info} setInfo={setInfo} />
      <Header bg={1} destination="/about" />
      <Control stage={stage} />
        <div className={"flex items-center align-middle w-full h-full"}>
        <div
          className={"mouse2 newbackToGalaxy text-xl"}
          onClick={(e) => close()}
        >
          {" "}
          [ BACK TO GALAXY ]{" "}
        </div>
        <div className="flex w-full p-20 stages" id="stage0">
          <textarea
            ref={idea}
            maxLength="512" //This is a really really bad idea
            id="idea"
            //onChange={handleChange1}
            //value={Phrase}
            autoFocus
            onFocus={function (e) {
              var val = e.target.value;
              e.target.value = "";
              e.target.value = val;
            }}
            placeholder="<please write your idea>"
            className="textArea w-full h-96 pt-1"
          />
        </div>
        <div className={"stages flex w-full p-20"} id="stage1">
          {`[ You should only mint your original ideas. You can also mint ideas of others, duly attributing them to their author, only if they are no longer covered by copyright or, if they are, with the author’s express authorization. Also your idea should not be derogatory or discriminatory for reasons of ethnicity, sexual orientation, political opinion, age or health, nor
 inciting to violence or crime (“Ethical Principles”). Failing this, your idea, while minted, will not be published.  ]`}
        </div>
        <div className="stages flex flex-col w-full p-20 text-center" id="stage2">
           <div
                className={free ? "seriesOn" : "seriesOff"}
                onClick={() => {
                  setFree(true);
                }}
              >
          [  TRY temporary publication (free) ]<br/>
          </div>
          or<br />
            <div
                className={!free ? "seriesOn" : "seriesOff"}
                onClick={() => {
                  setFree(false);
                }}
              >
          [ mint, make eternal and if you like, try to sell ]
        </div>
          </div>
        <div className={"stages flex w-full p-20"} id="stage3">
          <div className="wouldYou">
            Would you like to:
            <div className="options">
              <div
                className={sig.signed ? "seriesOn" : "seriesOff"}
                onClick={() => {
                  setSig({ signed: 1, sig: "" });
                }}
              >
                Attribute the idea
              </div>
              or
              <div
                className={!sig.signed ? "seriesOn" : "seriesOff"}
                onClick={() => {
                  setSig({ signed: 0, sig: "" });
                }}
              >
                remain anonymous
              </div>
            </div>
            <div className="sigdiv">
              {sig.signed ? (
                <input
                  className="sig"
                  id="sig"
                  placeholder="sign"
                  maxLength="40"
                  autoFocus
                  onFocus={function (e) {
                    e.target.placeholder = "";
                  }}
                  onChange={function (e) {
                    if (e.target.value === "") {
                      e.target.placeholder = "Author";
                    }
                  }}
                  onBlur={function (e) {
                    if (e.target.value === "") {
                      e.target.placeholder = "Author";
                    }
                  }}
                />
              ) : null}
            </div>
          </div>
        </div>
        <div className={"stages flex w-full p-20"} id="stage4">
          <div className="wouldYou">
            <div className="inside"> Are you mintint it to : </div>
            <br />
            <div className="options">
              <span
                className={priv ? "seriesOff" : "seriesOn"}
                onClick={() => {
                  setPriv(0);
                }}
              >
               Put it for sale 
              </span>
              or
              <span
                className={!priv ? "seriesOff" : "seriesOn"}
                onClick={() => {
                  setPriv(1);
                }}
              >
                {" "}
               keep it confidential?
              </span>
            </div>

            <div className="Moneydiv">
              {!priv ? (
                <>
                  {/*check if format number ! */}
                  <input
                    className="sig"
                    placeholder="price"
                    id="price"
                    maxLength="10"
                    autoFocus
                    onFocus={function (e) {
                      e.target.placeholder = "price";
                    }}
                    onChange={function (e) {
                      if (e.target.value === "") {
                        e.target.placeholder = "price";
                      }
                    }}
                    onBlur={function (e) {
                      if (e.target.value === "") {
                        e.target.placeholder = "price";
                      }
                    }}
                  />
                  <div className={"seriesOff coin"}>Euros</div>
                </>
              ) : null}
            </div>
          </div>
        </div>
        <div className={"stages flex w-full p-20"} id="stage5">
          <span>
            <span
              className={serie === 0 ? "seriesOn" : "seriesOff"}
              onClick={() => {
                setSerie(0);
              }}
            >
              [ unique ]
            </span>
            <br />
            OR EDITION :
            <br />
            <span
              className={serie === 1 ? "seriesOn" : "seriesOff"}
              onClick={() => {
                setSerie(1);
              }}
            >
              [ edition of 10 ]
            </span>
            <br />
            <span
              className={serie === 2 ? "seriesOn" : "seriesOff"}
              onClick={() => {
                setSerie(2);
              }}
            >
              [ edition of 20 ]
            </span>
            
          </span>
        </div>
        <div className={"stages flex w-full p-20"} id="stage6">
          <WalletConnectDivs />
        </div>
        <div className={"stages flex w-full p-20 "} id="stage7">
          <div className="w-1/2 flex-row  text-center border-0 ">
            <div className="flex ">
              <div className=" w-1/3 ">
                Name:
              </div>
              <div className="flex-1 text-sm">
                <input
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className=" text-2xl w-2/3" />
              </div>
            </div>

            <div className="flex flex-col">
              <div className= " flex-row flex">
                <div className=
                  {europe === 1 ? "seriesOn w-1/2 mouse2 " : "seriesOff w-1/2 mouse2"}   onClick={() => setEurope(1)} >
                Europe 
                </div>
                /
                 <div className={europe === 0 ? "seriesOn w-1/2 mouse2 " : "seriesOff w-1/2 mouse2"} onClick={() => setEurope(0)}>
                Rest of the world
              </div>
              </div>
            
            </div>

        
          </div>
        </div>
        <div className={"stages flex w-full p-20"} id="stage8">
          <div className="border-0 text-center">
          {userinfo.id === 0 ? (
            <LoginProcess callback={afterLogin} />
            ) : (
                <>
            <span
              className="mouse selected"
                    onClick={() => {
                      if (terms == "")
                        setTerms("X");
                      else
                        setTerms("");
              }}
            >
                    ACCEPT TERMS AND CONDITIONS [{terms}]<br></br>
                    
                  </span>
                  <span className="text-lg mouse selected" onClick={() => openN("https://hyperuranium.io/static/media/legal.de3ba7b8fbe9ded37ee8.pdf")}>you can read them here</span><br />
                  {terms == "X" ?
                    <span
                      className="mouse selected"
                      onClick={() => {
                        if (terms == "X")
                          handleSave();
                      }}
                    >
                      { free ? "[ submit ]" : "[ MINT ]" }
                    </span>
                    :
                    null
                  }
                  </>
          )}
            <br />
           
          {isAdmin ? 
                    <span
              className="mouse selected text-center"
              onClick={() => {
                handleSave_admin();
              }}
            >
                  <span className="text-red-500"> [ ADMINT ] </span>
              </span>
                    :
                    null
                }
              </div>
              
              
        </div>
        <div className={"stages flex w-full p-20"} id="stage9">
          {stage === 9 ? <Stage9 /> : null}
        </div>
        <div className={"stages flex w-full p-20 items-center"} id="stage10">
          {free ? 
            
            <div className="paidThanks text-xl2 ">
              Thank you!<br />
              your idea is now going throught the hyperuranium <br />
              aproval process, before being published for free for 60 days. <br />
              after that period you will  be offered to mint it ,<br />
              failing which it will be cancelled .<br />
              </div>
              :
               <div className="paidThanks text-xl2 ">
            Thanks for minting your idea on hyperuranium, <br />
            your idea is now going throught the hyperuranium <br />
            aproval process, before being published <br />
            <br />
            
          </div>
            }
          <div
            className="text-xl mouse2 paidButton"
            onClick={() => {
              open("/");
            }}
          >
            [back]
          </div>
        </div>
      </div>
    </div>
  );
}

export default New;